import { images } from "../constants";

const home = [
    {
        id: 1,
        image: images.home1,
        subtitle: "Witajcie w dworze Imielno",
        headingPart1: "Zakładając",
        spanText: "ogród wierzymy w",
        headingPart2: "jutro",
        buttonText: "Skontaktuj się z nami",
        buttonLink: 'Skontaktuj-sie'
    },
    {
        id: 2,
        image: images.home2,
        subtitle: "Witajcie w dworze Imielno",
        headingPart1: "Wyjątkowe",
        spanText: "miejsce stworzone z",
        headingPart2: "pasją",
        buttonText: "Skontaktuj się z nami",
        buttonLink: 'Skontaktuj-sie'
    },
    {
        id: 3,
        image: images.home3,
        subtitle: "Witajcie w dworze Imielno",
        headingPart1: "Zabytkowy",
        spanText: "Zespół Dworsko-Parkowy w",
        headingPart2: "Imielnie",
        buttonText: "Skontaktuj się z nami",
        buttonLink: 'Skontaktuj-sie'
    },
];

export default home;